const links = [
  {
    label: "Facebook",
    url: "https://www.facebook.com/WashingtoniGEM",
    // iconSrc: "https://cdn-icons-png.flaticon.com/512/174/174848.png"
    iconSrc: "facebook"
  },
  {
    label: "Instagram",
    url: "https://www.instagram.com/washington_igem/",
    iconSrc: "instagram"
    // iconSrc: "https://cdn2.iconfinder.com/data/icons/social-media-applications/64/social_media_applications_3-instagram-512.png"
  },
  {
    label: "Twitter",
    url: "https://twitter.com/uw_igem_team",
    iconSrc: "twitter"
    // iconSrc: "https://cdn-icons-png.flaticon.com/512/733/733579.png"
  },
  {
    label: "Github",
    url: "https://github.com/uwigem",
    iconSrc: "github"
    // iconSrc: "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png"
  }
]
export default links
